import { Component, Input, OnInit } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';

@Component({
    selector: 'xfeet-bo-formly-wrapper-panel',
    template: `
    <div class="card my-1 p-0" [style.display]="!isDisplayed ? 'none' : ''">
      <h5 class="card-header p-0">
        <a href="javascript:void(0);" class="btn w-100" [class.btn-primary]="!isCollapsed" [class.btn-secondary]="isCollapsed" (click)="collapse.toggle()">{{ props.label }}</a>
      </h5>
      <div class="card-body p-2" #collapse="ngbCollapse" [(ngbCollapse)]="isCollapsed">
        <ng-container #fieldComponent></ng-container>
      </div>
    </div>
  `,
    standalone: false
})
export class FormlyPanelWrapperComponent extends FieldWrapper implements OnInit {
  @Input() isCollapsed = false;
  @Input() isDisplayed = true;
  constructor() {
    super();
  }

  ngOnInit(): void {
    this.isCollapsed = this.props?.attributes?.['isCollapsed'] === 'true';
    this.isDisplayed = this.props?.attributes?.['isDisplayed'] === 'true';
  }


}
